import { IMedicationTemplate } from "../../../../../utils/interfaces";
import { TextData } from "../../../../common/TextData/TextData";
import classes from "./ViewMedicationTemplateDetails.module.scss";

export const ViewMedicationTemplateDetails = ({ template }: { template: IMedicationTemplate }) => {
  const {
    name,
  } = template || {};

  return (
    <div className={classes.treatmentPlanDetailsContainer}>
      <h2>Medication template details</h2>
      <TextData name="Plan Name" value={name} />
    </div>
  );
};
